module.exports = __webpack_public_path__ + "static/Karaman-8ac2a14f98fa6a3dc2e808ebeb4b0ffc.png";